import { IAssessment, IDueDeliganceAssessment, IBudgetAssessment, IApplicationSection } from './assessmentForm.types';
import { ValidationMessage, IValidationMessage } from '@/entities/common';
import { AppConstants as _app } from '@/shared/app.constants';

export class AssessmentForm implements IAssessment {
    internalReviewId: number
    language: string
    usedTemplate: any
    templateList: any
    dueDeliganceAssessment: IDueDeliganceAssessment
    budgetAssessment: IBudgetAssessment
    applicationId: any
    internalReviewerId: any
    datum:any
    _id: string
    status: number
    version: string
    auditInfo: any
    selectedItem: string
    reviewHeader: any
    applicationSection: IApplicationSection
    reviewSections: Array<string>
    constructor(data: any) {
        this.internalReviewId = data.internalReviewerId;
        this.usedTemplate = data.usedTemplate;
        this.language = data.language || localStorage.getItem("language") || "en-US";
        this.templateList = data.templateList;
        this.datum = data.datum;
        this.dueDeliganceAssessment = new DueDeliganceAssessment(data.dueDeliganceAssessment || ({} as IDueDeliganceAssessment))
        this.budgetAssessment = new BudgetAssessment(data.budgetAssessment || ({} as IBudgetAssessment))
        this.applicationId = data.applicationId;
        this.internalReviewerId = data.internalReviewerId;
        this._id = data._id;
        this.status = data.status;
        this.version = data.version;
        this.auditInfo = data.auditInfo;
        this.reviewHeader = data.reviewHeader;
        this.selectedItem = data.selectedItem || _app.assessmentWorkspace.default_menu;
        this.applicationSection = new ApplicationSection(data.applicationSection || ({} as IApplicationSection));
        this.reviewSections = data.reviewSections || [];
    }
}

/** class for application due deligence */
export class DueDeliganceAssessment implements IDueDeliganceAssessment {
    templates: any
    selectedKey: string
    data: any
    showValidationDialog: boolean
    validationMessages: Array<IValidationMessage>
    constructor(dueDeliganceAssessment: IDueDeliganceAssessment) {
        this.templates = dueDeliganceAssessment.templates || {}
        this.data = dueDeliganceAssessment.data || {}
        this.selectedKey = dueDeliganceAssessment.selectedKey || _app.assessmentWorkspace.default_dd_review_key
        this.validationMessages = (dueDeliganceAssessment.validationMessages || []).map((x) => new ValidationMessage(x))
        this.showValidationDialog = dueDeliganceAssessment.showValidationDialog || false;
    }
}

/** class for application budget assessment*/
export class BudgetAssessment implements IBudgetAssessment {
    templates: any
    selectedKey: string
    data: any
    showValidationDialog: boolean
    validationMessages: Array<IValidationMessage>
    constructor(budgetAssessment: IBudgetAssessment) {
        this.templates = budgetAssessment.templates || {}
        this.data = budgetAssessment.data || {}
        this.selectedKey = budgetAssessment.selectedKey || _app.assessmentWorkspace.default_budget_review_key
        this.validationMessages = (budgetAssessment.validationMessages || []).map((x) => new ValidationMessage(x))
        this.showValidationDialog = budgetAssessment.showValidationDialog || false;
    }
}

export class ApplicationSection implements IApplicationSection {
    data: any;
    templates: any;
    language: string;
    appHeader: any;
    constructor(params) {
        this.data = params.data || {};
        this.templates = params.templates || {};
        this.appHeader = params.appHeader || {};
        this.language = params.language || _app.workspace.default_lang;
    }
}